/**
 * Check if a route can be access, return a appropriate route otherwise
 * If a authentification is necessary, a redirect url is stored in the session storage
 * @param {*} to
 * @returns {Object|null}
 */
export function useRouteValidation(to) {
  const authStore = useAuthStore();
  const sessionStorage = useSessionStorage();
  const { UNKNOWN, ANONYMOUS, CONNECTED, CONTROLLED } = useAuthStatus;
  const router = useRouter();
  let route = null;
  let redirect = null;

  // Not in control state
  if (!authStore.isConnected || authStore.isControlled) {
    switch (to.meta.auth) {
      case UNKNOWN:
        if (authStore.isConnected) {
          route = "/compte";
        } else if (!authStore.isUnknown) {
          route = "/authentification";
        }
        break;
      case ANONYMOUS:
        if (authStore.isConnected) {
          route = "/compte";
        }
        break;
      case CONNECTED:
        if (authStore.isControlled) {
          route = "/compte";
        } else if (!authStore.isConnected) {
          route = "/authentification";
          redirect = to.fullPath;
        }
        break;
      case CONTROLLED:
        if (!authStore.isControlled) {
          route = "/authentification";
          redirect = to.fullPath;
        }
        break;
      default:
        break;
    }
  } else if (to.name !== "controle") {
    route = "/controle";
    redirect = to.fullPath;
  }

  // Can't have a route with ?redirect=/controle

  if (redirect) {
    const redirectRoute = router.resolve(redirect);
    if (!redirectRoute.meta.noRedirect) {
      sessionStorage.set("redirect", redirect);
    }
  }

  return route;
}
